//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { BookingPriceOverrideItem } from './BookingPriceOverrideItem';
import { WebsiteBlockSignupFormAdditionalFieldsInputItem } from './WebsiteBlockSignupFormAdditionalFieldsInputItem';
import { WebsiteCustomFieldSignupFormInputItem } from './WebsiteCustomFieldSignupFormInputItem';
import { WebsiteBlockInputItem } from './WebsiteBlockInputItem';
import { StudentStatus, StudentTypes, SignupPaymentType, WebsiteBlockSignupFormType, WebsiteBlockType } from './Enums';

export class WebsiteBlockSignupFormInputItem extends WebsiteBlockInputItem {
    Header: string | null = null;
    DefaultStudentStatus: StudentStatus = StudentStatus.Active;
    AllowedStudentTypes: StudentTypes = StudentTypes.ChildOnly;
    TagIDs: string[] = [];
    TeacherIDs: string[] = [];
    EventCategoryIDs: string[] = [];
    PaymentType: SignupPaymentType | null = null;
    RegistrationFeeDescription: string | null = null;
    RegistrationFeeAmount: number | null = null;
    RegistrationFeeChargeCategoryID: string | null = null;
    DepositAmount: number | null = null;
    HoldTimeSlot: boolean = false;
    BookingPriceOverride: BookingPriceOverrideItem | null = null;
    SendLoginInformation: boolean = false;
    SendConfirmationEmail: boolean = false;
    EmailTemplateSubject: string | null = null;
    EmailTemplateBody: string | null = null;
    ThankYouMessage: string | null = null;
    SignupFormType: WebsiteBlockSignupFormType = WebsiteBlockSignupFormType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.SignupForm;
    AdditionalFields: WebsiteBlockSignupFormAdditionalFieldsInputItem | null = null;
    CustomFields: WebsiteCustomFieldSignupFormInputItem[] = [];

    constructor(initializer?: Partial<Omit<WebsiteBlockSignupFormInputItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockSignupFormInputItem";
}
